import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, computed } from 'vue';
import { useRouter } from 'vue-router/composables';

import {
  BaseText,
  Heading,
  Row,
  HeadingDisplay,
  InitialAvatarIcon
} from '@warrenbrasil/nebraska-web';
import { HandleSection } from '@/modules/trade/components/HandleSection';
import { Money } from '@/modules/common/components/MoneyV2';

import {
  getPositionsSummary,
  PositionsSummaryResponse
} from '@/modules/trade/services/instruments';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';


export default /*#__PURE__*/_defineComponent({
  __name: 'PositionsSummarySection',
  setup(__props) {

const router = useRouter();

const error = ref(false);
const loading = ref(true);
const positionsSummary = ref<PositionsSummaryResponse | null>(null);

const hasPositions = computed(
  () => positionsSummary.value && positionsSummary.value.length > 0
);

const shouldRenderShowDetailsButton = computed(
  () => positionsSummary.value && positionsSummary.value.length > 1
);

const checkIfAllPositionsSummaryFailed = (
  positionsSummary: PositionsSummaryResponse
) => {
  return (
    positionsSummary.length > 0 &&
    positionsSummary.every(position => position.error)
  );
};

const fetchPositionsSummary = async () => {
  try {
    loading.value = true;
    error.value = false;

    const data = await getPositionsSummary();
    positionsSummary.value = data;

    if (checkIfAllPositionsSummaryFailed(positionsSummary.value))
      error.value = true;
  } catch {
    error.value = true;
  } finally {
    loading.value = false;
  }
};

function goToOrders() {
  router.push({ name: 'orders' });
}

onMounted(fetchPositionsSummary);

return { __sfc: true,router, error, loading, positionsSummary, hasPositions, shouldRenderShowDetailsButton, checkIfAllPositionsSummaryFailed, fetchPositionsSummary, goToOrders, BaseText, Heading, Row, HeadingDisplay, InitialAvatarIcon, HandleSection, Money, NebraskaColors }
}

})